module.exports = {
    baseUrl: 'https://www.crossea.com/prod-api',
}
